webpackJsonp([0],{

/***/ "+0hf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/3XS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Item__ = __webpack_require__("B91n");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var Room = function (_Item) {
  _inherits(Room, _Item);

  _createClass(Room, [{
    key: 'center',
    get: function get() {
      return { x: Math.floor((this.x1 + this.x2) / 2), y: Math.floor((this.y1 + this.y2) / 2) };
    }
  }]);

  function Room(x, y, w, h) {
    _classCallCheck(this, Room);

    var _this = _possibleConstructorReturn(this, (Room.__proto__ || Object.getPrototypeOf(Room)).call(this, 0));

    _this.x1 = x;
    _this.x2 = x + w;
    _this.y1 = y;
    _this.y2 = y + h;
    return _this;
  }

  _createClass(Room, [{
    key: 'intersects',
    value: function intersects(room) {
      return this.x1 <= room.x2 && this.x2 >= room.x1 && this.y1 <= room.y2 && this.y2 >= room.y1;
    }
  }]);

  return Room;
}(__WEBPACK_IMPORTED_MODULE_0__Item__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Room);

/***/ }),

/***/ "2BSB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Item__ = __webpack_require__("B91n");
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var Portal = function (_Item) {
  _inherits(Portal, _Item);

  function Portal() {
    _classCallCheck(this, Portal);

    return _possibleConstructorReturn(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).call(this, 6));
  }

  return Portal;
}(__WEBPACK_IMPORTED_MODULE_0__Item__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Portal);

/***/ }),

/***/ "2HYv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2UlX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Item__ = __webpack_require__("B91n");
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var Health = function (_Item) {
  _inherits(Health, _Item);

  function Health() {
    _classCallCheck(this, Health);

    var _this = _possibleConstructorReturn(this, (Health.__proto__ || Object.getPrototypeOf(Health)).call(this, 3));

    _this.amount = 20;
    return _this;
  }

  return Health;
}(__WEBPACK_IMPORTED_MODULE_0__Item__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Health);

/***/ }),

/***/ "2h37":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"map"},_vm._l((_vm.mapArr),function(row,index){return _c('ul',{key:index,staticClass:"row"},_vm._l((row),function(item,i){return _c('li',{key:i,staticClass:"item",class:_vm.getClass(item)})}))}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6YjZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Item__ = __webpack_require__("B91n");
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var Enemy = function (_Item) {
  _inherits(Enemy, _Item);

  function Enemy(attack, health, xp) {
    _classCallCheck(this, Enemy);

    var _this = _possibleConstructorReturn(this, (Enemy.__proto__ || Object.getPrototypeOf(Enemy)).call(this, 5));

    _this.attack = attack;
    _this.health = health;
    _this.xp = xp;
    return _this;
  }

  return Enemy;
}(__WEBPACK_IMPORTED_MODULE_0__Item__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Enemy);

/***/ }),

/***/ "B91n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Item = function Item(id) {
  var x = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var y = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

  _classCallCheck(this, Item);

  this.id = id;
  this.x = x;
  this.y = y;
};

/* harmony default export */ __webpack_exports__["a"] = (Item);

/***/ }),

/***/ "BfQQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CuIE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("oiih");
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    sight: {
      type: Number,
      required: true
    }
  },
  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])(['mapArr']),
  methods: {
    getClass: function getClass(obj) {
      var className = __WEBPACK_IMPORTED_MODULE_1__constants__["d" /* itemClasses */][obj.id];
      var diffX = this.$store.state.player.x - obj.x,
          diffY = this.$store.state.player.y - obj.y;
      if ((Math.abs(diffX) > this.sight || Math.abs(diffY) > this.sight) && this.$store.state.darkness) {
        className += ' dark';
      } else if (Math.sqrt(Math.pow(diffX, 2) + Math.pow(diffY, 2)) >= this.sight && this.$store.state.darkness) {
        className += ' dark';
      }
      return className;
    }
  }
});

/***/ }),

/***/ "JsAz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',{staticClass:"title"},[_vm._v("Find an kill the boss in Dungeon 3")]),_vm._v(" "),_c('div',{staticClass:"player-status"},[_c('div',{staticClass:"player-status__item"},[_vm._v("\n      Health: "+_vm._s(_vm.$store.state.player.health)+"\n      "),_c('div',{staticClass:"player-status__item__events"},[_c('transition-group',{attrs:{"name":"event"}},_vm._l((_vm.$store.state.healthHistory),function(item,i){return _c('div',{key:i,staticClass:"player-status__item__events__event",style:({'color':  item >= 0 ? 'darkolivegreen' : 'firebrick'})},[_vm._v("\n          "+_vm._s(item)+"\n        ")])}))],1)]),_vm._v(" "),_c('div',{staticClass:"player-status__item"},[_vm._v("\n      Weapon: "+_vm._s(_vm.$store.state.player.weapon.name)+" - "+_vm._s(_vm.$store.state.player.weapon.attack)+" Att.\n      "),_c('div',{staticClass:"player-status__item__events"},[_c('transition-group',{attrs:{"name":"event"}},_vm._l((_vm.$store.state.attackHistory),function(item,i){return _c('div',{key:i,staticClass:"player-status__item__events__event",staticStyle:{"color":"darkolivegreen"}},[_vm._v("\n          Dealt "+_vm._s(item)+" damage\n        ")])}))],1)]),_vm._v(" "),_c('div',{staticClass:"player-status__item"},[_vm._v("Xp: "+_vm._s(_vm.$store.state.player.xp))]),_vm._v(" "),_c('div',{staticClass:"player-status__item"},[_vm._v("Level: "+_vm._s(_vm.$store.state.player.level))]),_vm._v(" "),_c('div',{staticClass:"player-status__item"},[_vm._v("Dungeon: "+_vm._s(_vm.$store.state.dungeon))]),_vm._v(" "),_c('button',{staticClass:"button",on:{"click":function($event){_vm.toggleDarkness()}}},[_vm._v("Toggle Darkness")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KjvJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Enemy__ = __webpack_require__("6YjZ");
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var Boss = function (_Enemy) {
  _inherits(Boss, _Enemy);

  function Boss() {
    _classCallCheck(this, Boss);

    var _this = _possibleConstructorReturn(this, (Boss.__proto__ || Object.getPrototypeOf(Boss)).call(this, 25, 60, 99));

    _this.boss = true;
    _this.x2 = 0;
    _this.y2 = 0;
    return _this;
  }

  return Boss;
}(__WEBPACK_IMPORTED_MODULE_0__Enemy__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Boss);

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Game_vue__ = __webpack_require__("Of6H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Map_vue__ = __webpack_require__("ffxQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Player_vue__ = __webpack_require__("szlg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_store__ = __webpack_require__("wtEF");






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('rogue-map', __WEBPACK_IMPORTED_MODULE_2__Map_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('rogue-player', __WEBPACK_IMPORTED_MODULE_3__Player_vue__["a" /* default */]);
this.$bus = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]();

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  store: __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__Game_vue__["a" /* default */]);
  }
});

/***/ }),

/***/ "Of6H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Game_vue__ = __webpack_require__("T1UM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50515a20_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Game_vue__ = __webpack_require__("WIWu");
function injectStyle (ssrContext) {
  __webpack_require__("+0hf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Game_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50515a20_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Game_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "T1UM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__map__ = __webpack_require__("zD9L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__("oiih");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models_Player__ = __webpack_require__("yWX+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__models_Health__ = __webpack_require__("2UlX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__models_Enemy__ = __webpack_require__("6YjZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__models_Portal__ = __webpack_require__("2BSB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__models_Boss__ = __webpack_require__("KjvJ");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'game',
  created: function created() {
    var _this = this;

    this.init();
    this.$store.watch(function (state) {
      return state.dungeon;
    }, function (val) {
      return _this.init();
    });
    window.addEventListener('keydown', this.onKeyPress);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('keydown', this.onKeyPress);
  },

  methods: _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["a" /* mapActions */])(['moveRight', 'moveLeft', 'moveTop', 'moveBottom', 'tryAgain']), {
    init: function init() {
      var _this2 = this;

      var map = new __WEBPACK_IMPORTED_MODULE_1__map__["a" /* default */](50);

      // create player
      if (this.$store.state.dungeon === 0) {
        var player = new __WEBPACK_IMPORTED_MODULE_3__models_Player__["a" /* default */]();
        this.$store.commit('SET_PLAYER', player);
      }
      map.placeObject(this.$store.state.player);

      // create health
      Array.apply(undefined, _toConsumableArray(Array(5))).map(function (_) {
        return new __WEBPACK_IMPORTED_MODULE_4__models_Health__["a" /* default */]();
      }).forEach(function (h) {
        return map.placeObject(h);
      });

      // create enemies, make the enemies stronger based on the dungeon
      var randomAttribute = function randomAttribute() {
        return Math.floor(Math.random() * (_this2.$store.state.dungeon * 8 + 10) + 5 + _this2.$store.state.dungeon * 3);
      };
      Array.apply(undefined, _toConsumableArray(Array(8))).map(function (_) {
        return new __WEBPACK_IMPORTED_MODULE_5__models_Enemy__["a" /* default */](randomAttribute(), randomAttribute(), randomAttribute());
      }).forEach(function (e) {
        return map.placeObject(e);
      });

      // creates a weapon
      map.placeObject(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* weapons */][this.$store.state.dungeon + 1]);

      // if the player is not in the final dungeon place a portal
      if (this.$store.state.dungeon < 3) {
        map.placeObject(new __WEBPACK_IMPORTED_MODULE_6__models_Portal__["a" /* default */]());
      } else {
        map.placeBoss(new __WEBPACK_IMPORTED_MODULE_7__models_Boss__["a" /* default */]());
      }

      this.$store.commit('SET_MAP', map);
    },
    onKeyPress: function onKeyPress(e) {
      if (this.$store.state.lost) {
        return;
      }
      switch (e.keyCode) {
        case 39:
          this.moveRight();
          break;
        case 37:
          this.moveLeft();
          break;
        case 38:
          this.moveTop();
          break;
        case 40:
          this.moveBottom();
      }
    },
    again: function again() {
      this.tryAgain();
      this.init();
    }
  })
});

/***/ }),

/***/ "WIWu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"game",style:({ 'background-color': _vm.$store.state.darkness ? '#333' : '#777'  })},[_c('rogue-player'),_vm._v(" "),_c('div',{staticClass:"map-container"},[_c('rogue-map',{attrs:{"sight":7}})],1),_vm._v(" "),(_vm.$store.state.lost || _vm.$store.state.won)?_c('div',{staticClass:"modal"},[_c('div',{staticClass:"modal__content"},[(_vm.$store.state.lost)?_c('h1',[_vm._v("Game Over!")]):_vm._e(),_vm._v(" "),(_vm.$store.state.won)?_c('h1',[_vm._v("Game Won!")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"button",on:{"click":function($event){_vm.again()}}},[_vm._v("Try again")])])]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "dhjq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Item__ = __webpack_require__("B91n");
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var Weapon = function (_Item) {
  _inherits(Weapon, _Item);

  function Weapon(name, attack) {
    _classCallCheck(this, Weapon);

    var _this = _possibleConstructorReturn(this, (Weapon.__proto__ || Object.getPrototypeOf(Weapon)).call(this, 4));

    _this.name = name;
    _this.attack = attack;
    return _this;
  }

  return Weapon;
}(__WEBPACK_IMPORTED_MODULE_0__Item__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Weapon);

/***/ }),

/***/ "ePkF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    toggleDarkness: function toggleDarkness() {
      this.$store.commit('SET_DARKNESS', !this.$store.state.darkness);
    }
  }
});

/***/ }),

/***/ "ffxQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Map_vue__ = __webpack_require__("CuIE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_657667ce_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Map_vue__ = __webpack_require__("2h37");
function injectStyle (ssrContext) {
  __webpack_require__("2HYv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Map_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_657667ce_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Map_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "oiih":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return levels; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return weapons; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return items; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return itemClasses; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__models_Weapon__ = __webpack_require__("dhjq");


var levels = [0, 50, 110, 180, 250, 999999];

var weapons = [new __WEBPACK_IMPORTED_MODULE_0__models_Weapon__["a" /* default */]('Stick', 7), new __WEBPACK_IMPORTED_MODULE_0__models_Weapon__["a" /* default */]('Speer', 12), new __WEBPACK_IMPORTED_MODULE_0__models_Weapon__["a" /* default */]('Sword', 18), new __WEBPACK_IMPORTED_MODULE_0__models_Weapon__["a" /* default */]('Katana', 24), new __WEBPACK_IMPORTED_MODULE_0__models_Weapon__["a" /* default */]('Morning star', 30)];

var items = {
  EMPTY: 0,
  WALL: 1,
  PLAYER: 2,
  HEALTH: 3,
  WEAPON: 4,
  ENEMY: 5,
  PORTAL: 6
};

var itemClasses = ['empty', 'wall', 'player', 'health', 'weapon', 'enemy', 'portal'];

/***/ }),

/***/ "szlg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Player_vue__ = __webpack_require__("ePkF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54765e42_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Player_vue__ = __webpack_require__("JsAz");
function injectStyle (ssrContext) {
  __webpack_require__("BfQQ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Player_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54765e42_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Player_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wtEF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models_Player__ = __webpack_require__("yWX+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models_Item__ = __webpack_require__("B91n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__("oiih");
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();








__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* default */]);

var state = {
  player: new __WEBPACK_IMPORTED_MODULE_2__models_Player__["a" /* default */](0, 0),
  map: [],
  darkness: true,
  lost: false,
  won: false,
  dungeon: 0,
  attackHistory: [],
  healthHistory: []
};

var mutations = {
  SET_DARKNESS: function SET_DARKNESS(state, payload) {
    state.darkness = payload;
  },
  SET_PLAYER: function SET_PLAYER(state, payload) {
    state.player = payload;
  },
  SET_DUNGEON: function SET_DUNGEON(state, payload) {
    state.dungeon = payload;
  },
  SET_WON: function SET_WON(state, payload) {
    state.won = payload;
  },
  SET_LOST: function SET_LOST(state, payload) {
    state.lost = payload;
  },
  MOVE_PLAYER: function MOVE_PLAYER(state, payload) {
    var _payload = _slicedToArray(payload, 2),
        x = _payload[0],
        y = _payload[1];

    var nextItem = state.map.map[state.player.x + x][state.player.y + y];
    switch (nextItem.id) {
      case __WEBPACK_IMPORTED_MODULE_4__constants__["c" /* items */].WALL:
        return;
      case __WEBPACK_IMPORTED_MODULE_4__constants__["c" /* items */].HEALTH:
        state.healthHistory.push(nextItem.amount);
        state.player.health += nextItem.amount;
        break;
      case __WEBPACK_IMPORTED_MODULE_4__constants__["c" /* items */].WEAPON:
        state.player.weapon = nextItem;
        break;
      case __WEBPACK_IMPORTED_MODULE_4__constants__["c" /* items */].ENEMY:
        var attack = Math.floor(Math.random() * state.player.weapon.attack + 10 * state.player.level + 5);
        var damage = nextItem.attack;
        state.attackHistory.push(attack);
        state.healthHistory.push(-damage);
        nextItem.health -= attack;
        state.player.health -= damage;
        // if the player has no health left, the game is lost
        if (state.player.health <= 0) {
          state.lost = true;
        }
        // if the enemy still has health left, don't move foreward
        if (nextItem.health > 0) {
          return;
        }
        // if the boss was beaten, the game is won
        if (nextItem.boss) {
          state.won = true;
          return;
        }
        state.player.xp += nextItem.xp;
        break;
      case __WEBPACK_IMPORTED_MODULE_4__constants__["c" /* items */].PORTAL:
        state.dungeon++;
    }
    state.map.map[state.player.x][state.player.y] = new __WEBPACK_IMPORTED_MODULE_3__models_Item__["a" /* default */](__WEBPACK_IMPORTED_MODULE_4__constants__["c" /* items */].EMPTY, state.player.x, state.player.y);
    state.player.x += x;
    state.player.y += y;
    state.map.map[state.player.x][state.player.y] = state.player;
  },
  SET_MAP: function SET_MAP(state, payload) {
    state.map = payload;
  }
};

var getters = {
  mapArr: function mapArr(state) {
    return state.map.map;
  },
  playerReference: function playerReference(state) {
    return state.map.map[state.player.x][state.player.y];
  }
};

var actions = {
  moveRight: function moveRight(_ref) {
    var commit = _ref.commit;

    commit('MOVE_PLAYER', [1, 0]);
  },
  moveLeft: function moveLeft(_ref2) {
    var commit = _ref2.commit;

    commit('MOVE_PLAYER', [-1, 0]);
  },
  moveBottom: function moveBottom(_ref3) {
    var commit = _ref3.commit;

    commit('MOVE_PLAYER', [0, 1]);
  },
  moveTop: function moveTop(_ref4) {
    var commit = _ref4.commit;

    commit('MOVE_PLAYER', [0, -1]);
  },
  tryAgain: function tryAgain(_ref5) {
    var commit = _ref5.commit;

    commit('SET_WON', false);
    commit('SET_LOST', false);
    commit('SET_DUNGEON', 0);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* default */].Store({
  actions: actions,
  getters: getters,
  state: state,
  mutations: mutations
}));

/***/ }),

/***/ "yWX+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Item__ = __webpack_require__("B91n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("oiih");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var Player = function (_Item) {
  _inherits(Player, _Item);

  function Player() {
    _classCallCheck(this, Player);

    var _this = _possibleConstructorReturn(this, (Player.__proto__ || Object.getPrototypeOf(Player)).call(this, 2));

    _this.health = 100;
    _this.weapon = __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* weapons */][0];
    _this.xp = 0;
    _this._level = 0;
    return _this;
  }

  _createClass(Player, [{
    key: 'level',
    get: function get() {
      // index of the next level equals the level of the current
      var nextLevel = __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* levels */][this._level + 1];
      if (this.xp > nextLevel) {
        this._level++;
      }
      return this._level;
    },
    set: function set(value) {
      this._level = value;
    }
  }]);

  return Player;
}(__WEBPACK_IMPORTED_MODULE_0__Item__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Player);

/***/ }),

/***/ "zD9L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__("oiih");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_Room__ = __webpack_require__("/3XS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models_Item__ = __webpack_require__("B91n");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }





var Map = function () {
  function Map(size) {
    _classCallCheck(this, Map);

    this.generateMap(size);
  }

  _createClass(Map, [{
    key: 'randomInt',
    value: function randomInt(min, max) {
      return Math.floor(Math.random() * (max - min)) + min;
    }
  }, {
    key: 'generateHCorridor',
    value: function generateHCorridor(x1, x2, y) {
      for (var x = Math.min(x1, x2); x < Math.max(x1, x2) + 1; x++) {
        this.map[x][y] = new __WEBPACK_IMPORTED_MODULE_2__models_Item__["a" /* default */](__WEBPACK_IMPORTED_MODULE_0__constants__["c" /* items */].EMPTY, x, y);
      }
    }
  }, {
    key: 'generateVCorridor',
    value: function generateVCorridor(y1, y2, x) {
      for (var y = Math.min(y1, y2); y < Math.max(y1, y2) + 1; y++) {
        this.map[x][y] = new __WEBPACK_IMPORTED_MODULE_2__models_Item__["a" /* default */](__WEBPACK_IMPORTED_MODULE_0__constants__["c" /* items */].EMPTY, x, y);
      }
    }

    /**
     * Generates a empty map with rooms
     * https://gamedevelopment.tutsplus.com/tutorials/create-a-procedurally-generated-dungeon-cave-system--gamedev-10099
     * @param {number} size
     */

  }, {
    key: 'generateMap',
    value: function generateMap(size) {
      var _this = this;

      this.map = Array.apply(undefined, _toConsumableArray(Array(size))).map(function (_, x) {
        return Array(size).fill().map(function (_, y) {
          return new __WEBPACK_IMPORTED_MODULE_2__models_Item__["a" /* default */](__WEBPACK_IMPORTED_MODULE_0__constants__["c" /* items */].WALL, x, y);
        });
      });
      var minRoomSize = 5,
          maxRoomSize = 15,
          rooms = [];

      var _loop = function _loop() {
        // generate random room width and height
        var w = _this.randomInt(maxRoomSize, minRoomSize);
        var h = _this.randomInt(maxRoomSize, minRoomSize);
        // generate random room position
        var x = _this.randomInt(size - w - 1, 1);
        var y = _this.randomInt(size - h - 1, 1);
        var newRoom = new __WEBPACK_IMPORTED_MODULE_1__models_Room__["a" /* default */](x, y, w, h);
        // if the room doesn't intersect with another, draw it and the necessary corridors
        if (!rooms.some(function (r) {
          return newRoom.intersects(r);
        })) {
          rooms.push(newRoom);
          _this.placeBigObject(newRoom, false);
          if (rooms.length > 1) {
            var prevCenter = rooms[rooms.indexOf(newRoom) - 1].center;
            // randomly start with horizontal or vertical corridors
            if (Math.random() > 0.5) {
              _this.generateHCorridor(prevCenter.x, newRoom.center.x, newRoom.center.y);
              _this.generateVCorridor(prevCenter.y, newRoom.center.y, prevCenter.x);
            } else {
              _this.generateVCorridor(prevCenter.y, newRoom.center.y, prevCenter.x);
              _this.generateHCorridor(prevCenter.x, newRoom.center.x, newRoom.center.y);
            }
          }
        }
      };

      while (rooms.length < 10) {
        _loop();
      }
    }

    /**
     * @param {* extends Item} obj
     */

  }, {
    key: 'placeObject',
    value: function placeObject(obj) {
      var placed = false;
      while (!placed) {
        var x = this.randomInt(this.map.length - 1, 1);
        var y = this.randomInt(this.map.length - 1, 1);
        if (this.map[x][y].id === __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* items */].EMPTY) {
          obj.x = x;
          obj.y = y;
          this.map[x][y] = obj;
          placed = true;
          return obj;
        }
      }
    }
  }, {
    key: 'placeBoss',
    value: function placeBoss(boss) {
      var _this2 = this;

      var placed = false,
          w = 2,
          h = 2;
      while (!placed) {
        var x1 = this.randomInt(this.map.length - w - 1, 1);
        var y1 = this.randomInt(this.map.length - h - 1, 1);
        var x2 = x1 + 1;
        var y2 = y1 + 1;
        var space = [[x1, y1], [x2, y1], [x1, y2], [x2, y2]];
        console.log(space);
        if (space.every(function (s) {
          return _this2.map[s[0]][s[1]].id === __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* items */].EMPTY;
        })) {
          boss = _extends({}, boss, { x1: x1, y1: y1, x2: x2, y2: y2 });
          this.placeBigObject(boss, true);
          placed = true;
        }
      }
    }

    /**
     * Places and object bigger than 1 Pixel
     * @param {* extends Item} obj
     * @param {boolean} useObj determines if the object is used or a new Object per pixel is generated
     */

  }, {
    key: 'placeBigObject',
    value: function placeBigObject(obj, useObj) {
      for (var x = obj.x1; x <= obj.x2; x++) {
        for (var y = obj.y1; y <= obj.y2; y++) {
          this.map[x][y] = useObj ? obj : new __WEBPACK_IMPORTED_MODULE_2__models_Item__["a" /* default */](obj.id, x, y);
        }
      }
    }
  }]);

  return Map;
}();

/* harmony default export */ __webpack_exports__["a"] = (Map);

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.757c509fa1ca32ce07d8.js